"use client";

import Link from "next/link";
import { analyticsEvents } from "@/components/analytics/Analytics";

const highOpportunityLinks = [
  {
    href: "/court-case-status",
    label: "Court case status online",
    description: "Check by CNR, case number, party name, advocate or court.",
  },
  {
    href: "/high-court-case-status",
    label: "High Court case status",
    description: "DHC, Bombay HC, Karnataka HC and other High Court matters.",
  },
  {
    href: "/chandigarh-court-case-status",
    label: "Chandigarh court case status",
    description: "Punjab & Haryana High Court and District Court Chandigarh.",
  },
  {
    href: "/bombay-high-court-case-tracking",
    label: "Bombay High Court case status",
    description: "Mumbai High Court matters, writ petitions, appeals and orders.",
  },
  {
    href: "/delhi-high-court-case-alerts",
    label: "DHC case status",
    description: "DHC case number, party-name and CNR tracking.",
  },
  {
    href: "/bangalore-court-case-tracking",
    label: "Bangalore court case status",
    description: "Bengaluru Urban, City Civil Court and Karnataka High Court.",
  },
  {
    href: "/supreme-court-case-status",
    label: "Supreme Court case status",
    description: "SLP, civil appeal, criminal appeal and writ petition tracking.",
  },
  {
    href: "/blog/supreme-court-case-status-diary-number-slp",
    label: "Supreme Court diary number status",
    description: "Diary number, SLP registration, defects, cause list and orders.",
  },
  {
    href: "/amritsar-court-case-tracking",
    label: "Amritsar court case status",
    description: "eCourts Amritsar, district court and hearing-date alerts.",
  },
  {
    href: "/karnataka-high-court-case-tracking",
    label: "Karnataka High Court case status",
    description: "Bengaluru HC matters, case numbers and party-name searches.",
  },
  {
    href: "/mumbai-district-court-case-tracking",
    label: "Mumbai district court case status",
    description: "Sessions Court, City Civil Court, Bandra Family Court and more.",
  },
  {
    href: "/noida-court-case-tracking",
    label: "Noida court case status",
    description: "Gautam Budh Nagar, Greater Noida and Surajpur Court matters.",
  },
  {
    href: "/lucknow-court-case-tracking",
    label: "Lucknow court case status",
    description: "District Court and Allahabad High Court Lucknow Bench.",
  },
  {
    href: "/chhattisgarh-high-court-bilaspur-case-alerts",
    label: "Chhattisgarh High Court case status",
    description: "Bilaspur High Court matters, orders and hearing dates.",
  },
];

interface HighOpportunityCourtLinksProps {
  surface: string;
  title?: string;
  intro?: string;
  limit?: number;
  compact?: boolean;
  className?: string;
}

export default function HighOpportunityCourtLinks({
  surface,
  title = "Popular court case status pages",
  intro,
  limit = highOpportunityLinks.length,
  compact = false,
  className = "",
}: HighOpportunityCourtLinksProps) {
  const links = highOpportunityLinks.slice(0, limit);

  return (
    <div className={className}>
      {(title || intro) && (
        <div className={compact ? "mb-5" : "mb-8 text-center"}>
          {title && (
            <h2 className={compact ? "text-lg font-semibold text-gray-900" : "text-2xl md:text-3xl font-semibold text-gray-900"}>
              {title}
            </h2>
          )}
          {intro && (
            <p className={compact ? "mt-2 text-sm text-gray-600" : "mx-auto mt-3 max-w-2xl text-base text-gray-600"}>
              {intro}
            </p>
          )}
        </div>
      )}

      <div className={compact ? "grid gap-3 sm:grid-cols-2" : "grid gap-4 sm:grid-cols-2 lg:grid-cols-3"}>
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            onClick={() => analyticsEvents.seoInternalLinkClicked(link.href, surface, link.label)}
            className="group rounded-lg border border-gray-200 bg-white p-4 text-left transition hover:border-primary-200 hover:shadow-md"
          >
            <span className="block text-sm font-semibold text-gray-900 transition group-hover:text-primary">
              {link.label}
            </span>
            <span className="mt-1 block text-sm leading-6 text-gray-600">
              {link.description}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
